/**
 * Skip to main content link — visible only on keyboard focus.
 * Place as the first child inside the layout wrapper.
 */
import { useTranslation } from 'react-i18next';

export function SkipLink() {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-lg focus:outline-none"
    >
      {t('skip-to-main-content', 'Skip to main content')}
    </a>
  );
}

export default SkipLink;
